import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {resetPasswordCheckHash, resetPasswordConfirm} from "../Auth/Actions";
import Input from '../../components/Input';
import {Button, buttonTypes} from '../../components/Button';

class ResetPassword extends React.Component {
  state = {
    error: {
      resetPasswordWrongHash: ''
    },
    resPassword: '',
    resConfirmPassword: ''
  };

  componentWillMount() {
    const {hash} = this.props.match.params;
    if (hash)
      setTimeout(() => {
        this.props.checkHash({token: hash})
      }, 200)
  }

  componentWillReceiveProps(next) {
    this.setState({error: {...next.error}})
  }

  handleChange(e) {
    const {value, name} = e.target;
    if (value.length > 1000) {
      this.setState({error: {[name]: 'Max length 1000 characters'}})
    } else {
      this.setState({
        [name]: value
      }, () => {
        this.setState({error: {}})
      });
    }
  }

  changePassword = () => {
    const {hash} = this.props.match.params;
    const {resPassword, resConfirmPassword} = this.state;
    if (!resPassword || resPassword.length < 6) {
      this.setState({error: {resPassword: 'Min length 6 characters'}})
    } else if (resPassword !== resConfirmPassword) {
      this.setState({error: {resPassword: 'Passwords does not match'}})
    } else {
      this.props.resetPassword({token: hash, newPassword: resPassword}, this.props.history)
    }
  };

  render() {
    const {
      resPassword,
      resConfirmPassword,
      error
    } = this.state;

    return (


      <div className="reset-password">
        <h3 className="modal__title">Reset Password</h3>
        {error.resetPasswordWrongHash && <p className="error-block">{error.resetPasswordWrongHash}</p>}
        <Input
          type="password"
          label="Password"
          placeholder="Password"
          value={resPassword}
          name="resPassword"
          error={error.resPassword}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="password"
          label="Confirm Password"
          placeholder="Password"
          value={resConfirmPassword}
          name="resConfirmPassword"
          error={error.resConfirmPassword}
          onChange={(e) => this.handleChange(e)}
        />
        <Button
          type={buttonTypes.AUTHENTICATION}
          name="Change Password"
          onClick={this.changePassword}
        />
      </div>
    )
  }
}

ResetPassword.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  checkHash: PropTypes.func,
  resetPassword: PropTypes.func,
};

export default connect(
  s => ({
    error: s.auth.error,
  }),
  d => ({
    checkHash: (data) => {
      d(resetPasswordCheckHash(data))
    },
    resetPassword: (data, history) => {
      d(resetPasswordConfirm(data, history))
    }
  }))
(ResetPassword);


// WEBPACK FOOTER //
// ./src/app/containers/ResetPassword/index.js